import { render, staticRenderFns } from "./SiteNavigation.vue?vue&type=template&id=4c2a7a7e&scoped=true"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"
import style0 from "./SiteNavigation.vue?vue&type=style&index=0&id=4c2a7a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a7a7e",
  null
  
)

export default component.exports